import { DolphinBookingIntentModelBase } from "./DolphinBookingIntentModel.base"


/* A graphql query fragment builders for DolphinBookingIntentModel */
export { selectFromDolphinBookingIntent, dolphinBookingIntentModelPrimitives, DolphinBookingIntentModelSelector } from "./DolphinBookingIntentModel.base"

/**
 * DolphinBookingIntentModel
 */
export const DolphinBookingIntentModel = DolphinBookingIntentModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
